import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelection,
  setSelectionFor,
  clearBooking,
  setBooking,
} from "redux/slices/booking";

import useAPI from "hooks/useAPI";

import { useHistory } from "react-router-dom";

import moment from "moment";

const useSelection = ({ key, setter }) => {
  const history = useHistory();
  const keyValidation = {
    where: () => {
      let obj = currentSelection.where;
      let selectedLocations = [];
      let objKeys = Object.keys(obj);
      selectedLocations = objKeys.filter((key) => obj[key]);
      return selectedLocations.length > 0;
    },
    when: () => {
      if (
        !currentSelection ||
        !currentSelection.when ||
        !currentSelection.when.date ||
        !currentSelection.when.startTime ||
        !currentSelection.when.endTime
      ) {
        console.warn("when is not defined");
        return false;
      }

      let when = currentSelection.when;

      let currentDateTime = moment();

      let startDateTime = moment(when.date);
      startDateTime.set({
        hour: when.startTime.split(":")[0],
        minute: when.startTime.split(":")[1],
      });

      let endDateTime = moment(when.date);
      endDateTime.set({
        hour: when.endTime.split(":")[0],
        minute: when.endTime.split(":")[1],
      });

      if (startDateTime.isBefore(currentDateTime.add(24, "hours"))) {
        console.warn(
          "startDateTime is before 24 hours from today - not enough time for team to sort booking"
        );
        return false;
      }

      if (endDateTime.diff(startDateTime, "hours") > 5) {
        console.warn(
          "endDateTime is more than 5 hours after startDateTime - too long of a booking"
        );
        return false;
      }

      return true;
    },
    what: () => {
      let what = currentSelection.what;
      if (!what) {
        return false;
      }

      let selections = [];

      what.forEach((activity) => {
        selections = selections.concat(activity.selections);
      });

      console.log("selections", selections);

      return selections.length >= 3;
    },
    anything: () => {
      let anything = currentSelection.anything;
      if (!anything) {
        return false;
      }

      //Must answer all questions
      if (
        anything.vibe.length === 0 ||
        anything.accessibility.length === 0 ||
        anything.fromLondon.length === 0
      ) {
        return false;
      }

      //Must add ntoes to accessibility
      if (
        anything.accessibility.indexOf("yes") > -1 &&
        (!anything.notes || anything.notes.length === 0)
      ) {
        return false;
      }

      return true;
    },
    budget: () => {
      let budget = currentSelection.budget;
      if (!budget) {
        return false;
      }

      return true;
    },
    confirm: () => {
      return false;
    },
  };

  const booking = useSelector((state) => state.booking);
  const currentSelection = useSelector((state) => state.booking.selection);
  const dispatch = useDispatch();
  const { API } = useAPI({});

  const [selectionHasUpdated, setSelectionHasUpdated] = useState(false);

  useEffect(() => {
    if (key && currentSelection[key] && setter) {
      setter(currentSelection[key]); //to set local component state
    }
  }, [currentSelection]);

  useEffect(() => {
    if (selectionHasUpdated) {
      updateServerIfStateUpdated();
    }
  }, [currentSelection]);

  const updateServerIfStateUpdated = async () => {
    //Auto updates on server
    setSelectionHasUpdated(false);
    await submitSelection();
  };

  const getAndSetSelectionByBookingId = async (bookingId) => {
    if (!bookingId) {
      return console.error("No booking id passed", bookingId, currentSelection);
    }
    try {
      let data = await API.get(`/bookings/${bookingId}`);
      let booking = data.booking;
      console.log("booking", booking);
      if (booking) {
        // dispatch(setSelection({ ...booking.selection, bookingId }));
        dispatch(setBooking(booking));
      } else {
        alert(
          "Trying to get a booking that either doesnt belong to the user or user needs to log in since the booking is assinged to a user whilst current user not logged in - selection will be cleared"
        );
        dispatch(clearBooking());
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const submitSelection = async () => {
    //Returns booking id of whats submitted
    console.log("submitSelection", currentSelection);

    if (!booking._id) {
      console.warn("submitSelection No booking id in current booking", booking);
      // return;
    } else {
      console.log("submitSelection booking id is in current booking", booking);
    }

    let bookingId = booking?._id;
    if (!bookingId) {
      try {
        let data = await API.post(`/bookings`, currentSelection);
        let newBooking = data.booking;
        console.log("newBooking created", newBooking);
        dispatch(setBooking(newBooking));
        bookingId = newBooking._id;
        // dispatch(setSelectionFor({ key: "bookingId", value: bookingId }));
      } catch (error) {
        console.log("error: ", error);
      }
    } else {
      try {
        let data = await API.put(`/bookings/${bookingId}`, currentSelection);
        let booking = data.updated;
        console.log("booking updated", booking);
      } catch (error) {
        console.log("error: ", error);
      }
    }
    return bookingId;
  };

  const keyIsValidated = (key) => {
    return keyValidation[key]();
  };

  return {
    setSelection: async (selection) => {
      console.log("useSelection setSelection", selection);
      dispatch(setSelection(selection));
      setSelectionHasUpdated(true);
    },
    setSelectionForKey: (value) => {
      console.log("set selection for", key, value);
      dispatch(setSelectionFor({ key, value }));
      setSelectionHasUpdated(true);
    },
    clearBooking: () => {
      dispatch(clearBooking());
    },
    keyIsValidated: keyIsValidated,

    redirectIfNotValidUpUntilKey: (key) => {
      let keys = Object.keys(keyValidation);
      let indexOfKey = keys.indexOf(key);
      let keysToValidate = keys.slice(0, indexOfKey);
      console.log("keysToValidate", keysToValidate);
      for (let i = 0; i < keysToValidate.length; i++) {
        let key = keysToValidate[i];
        if (!keyIsValidated(key)) {
          console.log("key is not valid so redirecting to it", key);
          history.push(`/${key}`);
          return;
        }
      }
    },

    keysAreValidatedUptoButNotIncluding: (key) => {
      let keys = Object.keys(keyValidation);
      let indexOfKey = keys.indexOf(key);
      let keysToValidate = keys.slice(0, indexOfKey);
      console.log("keysToValidate", keysToValidate);
      let allValid = true;
      keysToValidate.forEach((key) => {
        if (!keyIsValidated(key)) {
          allValid = false;
        }
      });
      return allValid;
    },
    submitSelection,
    getAndSetSelectionByBookingId,
  };
};

export default useSelection;
